/*!
 *
 *	fit-image.js
 *
 */

$.fn.fitImages = function(){
	this.each(function(){
		var $img = $(this),
			_img = $('<img />'),
			_src = $(this).attr('src')  + "?" + new Date().getTime(),
			default_width = $img.attr('width'),
			isHalf = false;

		if( $img.is('.half') ){
			isHalf = true;
		};

		_img.attr('src', _src).on('load', function(){
			var _w = $(this).prop('width');

			if( default_width != '' && default_width < _w ){
				_w = default_width;
			};

			_w+='px';

			if( _w != 0 ){
				//console.log(_w);
				$img.css({
					'width': '100%',
					'height': 'auto',
					'max-width': _w
				});
			};
			// if( $img.next('figcaption').length ){
			// 	$img.next('figcaption').css('max-width', _w);
			// };
			$(window).trigger('resize');
		});
	});
};


//////////////////
// WEBPACK FOOTER
// ./dev/js/components/module/fit-image.js
// module id = 22
// module chunks = 0